import apiClient from './apiClient';

class TrackingService {
    async trackShipment(awbNo) {
        try {
            const response = await apiClient.post('/track-shipment', {
                awb_no: awbNo
            });
            return {
                success: true,
                data: response.data.data
            };
        } catch (error) {
            console.error('Error tracking shipment:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to track shipment'
            };
        }
    }

    async addTrackingEntry(trackingData) {
        try {
            // For FormData uploads, we need to let the browser set Content-Type automatically
            const response = await apiClient.post('/tracking/add-entry', trackingData, {
                headers: {
                    'Content-Type': undefined // This removes the default application/json header
                }
            });
            return {
                success: true,
                data: response.data.data,
                message: response.data.message
            };
        } catch (error) {
            console.error('Error adding tracking entry:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to add tracking entry'
            };
        }
    }

    async getTrackingActivities() {
        try {
            const response = await apiClient.get('/tracking/activities');
            return {
                success: true,
                data: response.data.data
            };
        } catch (error) {
            console.error('Error fetching tracking activities:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to fetch activities'
            };
        }
    }

    async searchShipments(searchTerm) {
        try {
            const response = await apiClient.get('/tracking/search', {
                params: { search: searchTerm }
            });
            return {
                success: true,
                data: response.data.data
            };
        } catch (error) {
            console.error('Error searching shipments:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to search shipments'
            };
        }
    }

    async searchAllActiveBookings(searchTerm) {
        try {
            const response = await apiClient.get('/tracking/search-all-active', {
                params: { search: searchTerm }
            });
            return {
                success: true,
                data: response.data.data
            };
        } catch (error) {
            console.error('Error searching all active bookings:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to search active bookings'
            };
        }
    }

    async updateShipmentStatus(statusData) {
        try {
            const response = await apiClient.post('/tracking/update-status', statusData);
            return {
                success: true,
                data: response.data.data,
                message: response.data.message
            };
        } catch (error) {
            console.error('Error updating shipment status:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to update status'
            };
        }
    }

    async getTrackingHistory(awbNo) {
        try {
            const response = await apiClient.get(`/tracking/history/${awbNo}`);
            return {
                success: true,
                data: response.data.data
            };
        } catch (error) {
            console.error('Error fetching tracking history:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to fetch tracking history'
            };
        }
    }

    async updateTrackingEntry(entryId, trackingData) {
        try {
            // For FormData uploads, we need to let the browser set Content-Type automatically
            // const response = await apiClient.put(`/tracking/entry/${entryId}`, trackingData, {
            //     headers: {
            //         'Content-Type': undefined // This removes the default application/json header
            //     }
            // });
            const response = await apiClient.put(`/tracking/entry/${entryId}`, trackingData);
            return {
                success: true,
                data: response.data.data,
                message: response.data.message
            };
        } catch (error) {
            console.error('Error updating tracking entry:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to update tracking entry'
            };
        }
    }

    async deleteTrackingEntry(entryId) {
        try {
            const response = await apiClient.delete(`/tracking/entry/${entryId}`);
            return {
                success: true,
                message: response.data.message
            };
        } catch (error) {
            console.error('Error deleting tracking entry:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to delete tracking entry'
            };
        }
    }
}

export const trackingService = new TrackingService(); 